var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import customer from './customer';
import customerStatistics from './customer-statistics';
import quote from './quote';
import claim from './claim';
import policy from './policy';
import auth from './auth';
import saasPlatform from './saas-platform';
import product from './product';
import insuranceForm from './insurance-form';
import docuseal from './docuseal';
import crashReports from './crash-reports';
import prefill from './prefill';
var api = {
    auth: auth,
    customer: customer,
    customerStatistics: customerStatistics,
    quote: quote,
    claim: claim,
    policy: policy,
    insuranceForm: insuranceForm,
    saasPlatform: saasPlatform,
    product: product,
    docuseal: docuseal,
    crashReports: crashReports,
    prefill: prefill
};
export default api;
var API_URL = process.env.REACT_APP_BACKEND_API_URL;
// process.env.REACT_APP_NODE_ENV === 'production' ? process.env.REACT_APP_PROD_URL : process.env.REACT_APP_NODE_ENV === 'development' ? process.env.REACT_APP_DEV_URL : process.env.REACT_APP_NODE_ENV === 'staging' ? process.env.REACT_APP_STAGING_URL : null;
var instance = axios.create({
    baseURL: API_URL,
    headers: {
        // @ts-ignore
        common: {
        // can be common or any other method
        // Authorization: null,
        }
    }
});
export { instance };
// Response interceptor for API calls
instance.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var originalRequest;
        return __generator(this, function (_b) {
            originalRequest = error.config;
            if (((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 403 && !originalRequest._retry) {
                originalRequest._retry = true;
                // const access_token = await getToken();
                // axios.defaults.headers.common['Authorization'] = `${access_token}`;
                return [2 /*return*/, instance(originalRequest)];
            }
            return [2 /*return*/, Promise.reject(error)];
        });
    });
});
